<ng-guarantees-grid
  *ngIf="(store$ | async) as store"
  [loading]="store.loading"
  [configs]="configs"
  [data]="store.storageGuarantees"
  [invalidEquipments]="store.invalidEquipments"
  [type]="type"
  (refresh)="dispatchLoadData()"
  [activeEquipments]="store.activeEquipments"
></ng-guarantees-grid>
